<template>
	<div>
		<Subpage/>
	    <div class="page-content container">
			<main>            
				<h1 class="page-title">Kim jesteśmy?</h1>	            
				<div class="breadcrumbs-area">
				<nav aria-label="breadcrumb">
					<ol class="breadcrumbs" itemscope itemtype="http://schema.org/BreadcrumbList">
						<li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
							<router-link itemprop="item" to="/"><span itemprop="name">Strona gł&oacute;wna</span></router-link><span class="separator">/</span>
						</li>
						<li class="active">Kim jesteśmy?</li>
					</ol>
				</nav></div>    
			    <p>Witamy Państwa na stronie internetowej firmy Kontur.IT.</p>
				<p>Jeśli jesteście Państwo naszymi Klientami, doskonale zdajecie sobie sprawę z tego, że warto z nami wsp&oacute;łpracować i wiecie, że nie brak nam pasji i zaangażowania w tworzenie rzeczy nowych.</p>
				<p>Jeśli natomiast trafiliście Państwo do nas po raz pierwszy - postaramy się przekonać Was, że jako nasz Klient otrzymacie&nbsp;produkt idealnie dostosowany do Waszych potrzeb.</p>
				<p>Firma Kontur.IT powstała na bazie wieloletniego doświadczenia na rynku informatycznym, opartego na usługach i własnych produktach softwareowych.&nbsp;</p>
				<p>Zachęcamy do zapoznania się z informacją 
					<router-link to="/co-mozemy-dla-ciebie-zrobic">Co możemy dla Ciebie zrobić</router-link>.
				</p>
			</main>
	    </div>
	</div>
</template>
<script>
import Subpage from '@/components/Subpage.vue'
export default {
  name: 'About',
  components: {
    Subpage
  }
}
</script>
